import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';

export default function FooterV2() {
  return (
    <footer className="border-t border-white/10 bg-[#0a1425] mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4">
          {/* Brand */}
          <div className="space-y-4">
            <img src="/logo-btt.svg" alt="Better Together Training" className="h-12 w-12" />
            <h3 className="text-xl font-bold text-[#3B9AE1]">Better Together Training</h3>
            <p className="text-sm text-[#94a3b8]">
              Columbus, Ohio&apos;s premier basketball, swimming, and strength training program.
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com/tootall614"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#3B9AE1] transition hover:bg-[#2563eb]/20 hover:text-[#60a5fa]"
                title="Jalen — @tootall614"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://instagram.com/sukisinclair.robinson"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-[#3B9AE1] transition hover:bg-[#2563eb]/20 hover:text-[#60a5fa]"
                title="Sinclair — @sukisinclair.robinson"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Programs */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-[#cbd5e1]">Programs</h4>
            <ul className="space-y-2 text-sm text-[#94a3b8]">
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Basketball Training</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Swimming Programs</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Strength &amp; Conditioning</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Shallow Water Aerobics</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Group Lifeguarding Class</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Training Packages</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-[#cbd5e1]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[#94a3b8]">
              <li><Link to="/" className="transition hover:text-[#3B9AE1]">Home</Link></li>
              <li><Link to="/about" className="transition hover:text-[#3B9AE1]">About Us</Link></li>
              <li><Link to="/services" className="transition hover:text-[#3B9AE1]">Book Session</Link></li>
              <li><Link to="/contact" className="transition hover:text-[#3B9AE1]">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-[#cbd5e1]">Contact</h4>
            <ul className="space-y-3 text-sm text-[#94a3b8]">
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#3B9AE1]" />
                <span>(614) 869-7812</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#3B9AE1]" />
                <span>mr.robinson3704@gmail.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#3B9AE1]" />
                <span>Columbus, Ohio</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-[#94a3b8]">
          <p>&copy; {new Date().getFullYear()} Better Together Training LLC. All rights reserved.</p>
          <p className="mt-2">Site design by <a href="https://xigusa.com/solutions/website-design" target="_blank" rel="noopener noreferrer" className="text-[#3B9AE1] transition hover:text-[#60a5fa]">XIGUSA</a></p>
        </div>
      </div>
    </footer>
  );
}
